import React from 'react';
import classNames from 'classnames';

import Modal from '../Modal';
import PDPImageForm from '../PDPImageForm/PDPImageForm';

const ns = `quickshop`;

const Quickshop = ({
	location, product, setQuickShopOpen, quickShopOpen,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	const searchProduct = !!product.variants?.edges;

	const shortDescription = searchProduct ? product?.shortDescription : product?.metafields?.find(field => { return field.key === 'short_description'; });

	const adjustedProduct = {
		...product,
		isQuickshop: true,
		variants: searchProduct
			? product.variants.edges.map(edge => {
				return {
					...edge.node,
					storefrontId: edge.node.id,
					shopifyId: edge.node.id,
				};
			})
			: product.variants,
		priceRangeV2: product.priceRangeV2,
		title: product.title,
		images: searchProduct
			? product.images.edges.map(edge => { return edge.node; })
			: product.images,
	};

	return (
		<Modal
			modifier={rootClassnames}
			onRequestClose={() => { setQuickShopOpen(false); }}
			isOpen={quickShopOpen}
		>
			<div className={`${ ns }`}>
				{/* Only render form if quickshop is open */}
				{quickShopOpen && (
					<PDPImageForm
						location={location}
						product={adjustedProduct}
						shortDescription={shortDescription}
						setQuickShopOpen={setQuickShopOpen}
					/>
				)}
			</div>
		</Modal>
	);
};

export default Quickshop;
